import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerRightDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-corner-right-down"><path d="M4.75 3.75H15.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 16.25L15.25 20.25L19.25 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowCornerRightDown;
